/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { forwardRef, useRef, useState } from "react";
import { PiUsers } from "react-icons/pi";
import InputText from "../input/InputText";
import InputSelect from "../input/InputSelect";
import InputSelect2 from "../input/InputSelect2";
import { IoCloseOutline } from "react-icons/io5";
import toast from "react-hot-toast";
import useWaybill from "../../hooks/useWaybill";
import InputFile from "../input/InputFile";
import {
  createWaybillSchema,
  createWaybillSchemaTwo,
} from "../../utils/validationSchema/waybill";
import { httpClient, api } from "../../api/axios";
import SearchableDropdown2 from "../input/SearchableDropdown2";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatNumberOnInput, parseNumberInput } from "../../utils/utils";

const matchOption = (list, id, name) =>
  list?.find(
    (item) =>
      item.value === id ||
      item.value === Number(id) ||
      String(item.value) === String(id) ||
      item.label === name
  ) || null;

export const WaybillModal = ({
  model,
  closeModal,
  requestType,
  aggregatorList,
  recyclerList,
  getWaybills,
  userData,
  isAggregator,
  selectOptDefault,
  sourceOfPlastic,
  typeOfPlastic,
}) => {
  const modalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const { createNewWaybill, createNewWaybillAlte, updateExistingWaybill } =
    useWaybill();
  const { program } = useSelector((state) => state.auth);
  const isEdit = requestType === "edit";

  const initialValues = {
    amount:
      isEdit && userData?.amount
        ? formatNumberOnInput(String(userData.amount))
        : "",
    quantity:
      isEdit && userData?.quantity
        ? formatNumberOnInput(String(userData.quantity), {
            allowDecimals: true,
            maxDecimals: 2,
          })
        : "",
    aggregatorId: isEdit
      ? matchOption(aggregatorList, userData?.aggregatorId, userData?.aggregator)
          ?.value ||
        userData?.aggregatorId ||
        ""
      : "",
    recyclerId: isEdit
      ? matchOption(recyclerList, userData?.recyclerId, userData?.recycler)
          ?.value ||
        userData?.recyclerId ||
        ""
      : "",
    sourceOfPlastic: isEdit
      ? matchOption(
          sourceOfPlastic,
          userData?.sourceOfPlasticId,
          userData?.sourceOfPlastic
        )?.value ||
        userData?.sourceOfPlasticId ||
        ""
      : "",
    typeOfPlastic: isEdit
      ? matchOption(
          typeOfPlastic,
          userData?.typeOfPlasticId,
          userData?.typeOfPlastic
        )?.value ||
        userData?.typeOfPlasticId ||
        ""
      : "",
    transactionDate: isEdit ? userData?.transactionDate || "" : "",
    file: null,
  };

  const buildFormData = (data) => {
    const formData = new FormData();
    formData.append("amount", parseNumberInput(data.amount));
    formData.append("quantity", parseNumberInput(data.quantity));
    formData.append(
      "aggregatorId",
      isAggregator ? selectOptDefault?.value : data.aggregatorId
    );
    formData.append("programId", program);
    formData.append("recyclerId", data.recyclerId);
    formData.append("sourceOfPlasticId", data.sourceOfPlastic);
    formData.append("typeOfPlasticId", data.typeOfPlastic);
    formData.append("transactionDate", data.transactionDate);
    if (data?.file) {
      formData.append("file", data.file);
    }
    if (isEdit) {
      formData.append("id", userData.id);
    }
    return formData;
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const formData = buildFormData(data);
      if (isEdit) {
        const res = await updateExistingWaybill(formData);
        if (res.code === "00") {
          toast.success("Offtake updated");
          closeModal();
        }
        if (res.code !== "00") {
          setLoading(false);
          toast.error(res.message || "Error updating Offtake");
        }
      } else {
        const res = data?.file
          ? await createNewWaybill(formData)
          : await createNewWaybillAlte(formData);
        if (res.code === "00") {
          toast.success("Offtake created");
          closeModal();
        }
        if (res.code !== "00") {
          setLoading(false);
          toast.error(res.message || "Error creating Offtake");
        }
      }
    } catch (error) {
      toast.error(error.message || "something went wrong");
    } finally {
      setLoading(false);
      getWaybills();
    }
  };

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="flex flex-col">
      <label className={`after:content-['*'] after:text-red-500`}>
        Transaction Date
      </label>
      <div
        className="example-custom-input border border-gray-300 h-[44px] w-[140px] md:w-[200px] lg:w-[288px] p-2 rounded-md"
        onClick={onClick}
        ref={ref}
      >
        <h3>{value ? value : "Select date"}</h3>
      </div>
    </div>
  ));

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={
        isAggregator ? createWaybillSchemaTwo : createWaybillSchema
      }
      onSubmit={onSubmit}
    >
      {({ handleChange, errors, values, handleSubmit, setFieldValue }) => {
        return (
          <Form>
            <div>
              <div className="flex flex-col gap-y-2 md:w-[640px] lg:w-[640px] bg-white p-4 h-max">
                <div className="flex justify-between">
                  <PiUsers style={{ width: 26, height: 26 }} />
                  <IoCloseOutline
                    style={{ width: 26, height: 26, cursor: "pointer" }}
                    onClick={() => closeModal()}
                  />
                </div>
                <div className="">
                  <h1 className="capitalize font-bold">
                    {requestType === "edit"
                      ? "Edit Offtake"
                      : "Create new Offtake"}
                  </h1>
                  <p className="text-sm">Enter the details below</p>
                </div>
                <div className="flex justify-between gap-2">
                  <InputText
                    label={"Quantity(Kg)"}
                    placeholder={"Enter quantity"}
                    name="quantity"
                    value={values.quantity}
                    error={errors.quantity}
                    handleChange={(e) =>
                      setFieldValue(
                        "quantity",
                        formatNumberOnInput(e.target.value, {
                          allowDecimals: true,
                          maxDecimals: 2,
                        })
                      )
                    }
                  />
                  <InputText
                    label={"Amount(NGN)"}
                    placeholder={"Enter amount"}
                    name="amount"
                    value={values.amount}
                    error={errors.amount}
                    handleChange={(e) =>
                      setFieldValue(
                        "amount",
                        formatNumberOnInput(e.target.value)
                      )
                    }
                  />
                </div>

                <div className="flex justify-between gap-2 w-full">
                  {!isAggregator ? (
                    <SearchableDropdown2
                      label={"Aggregator"}
                      options={aggregatorList}
                      error={errors.aggregatorId}
                      selectedOption={
                        matchOption(
                          aggregatorList,
                          values.aggregatorId,
                          userData?.aggregator
                        ) ||
                        (values.aggregatorId
                          ? {
                              label: userData?.aggregator || "",
                              value: values.aggregatorId,
                            }
                          : null)
                      }
                      dropDownStyle={{
                        display: isAggregator ? "none" : "block",
                      }}
                      placeholder="Select  aggregator"
                      handleChange={(e) =>
                        setFieldValue("aggregatorId", e.value)
                      }
                    />
                  ) : (
                    ""
                  )}

                  <SearchableDropdown2
                    label={"Offatker"}
                    options={recyclerList}
                    error={errors.recyclerId}
                    selectedOption={
                      matchOption(
                        recyclerList,
                        values.recyclerId,
                        userData?.recycler
                      ) ||
                      (values.recyclerId
                        ? {
                            label: userData?.recycler || "",
                            value: values.recyclerId,
                          }
                        : null)
                    }
                    className={`${isAggregator ? "w-full" : ""}`}
                    placeholder="Select offaker"
                    handleChange={(e) => setFieldValue("recyclerId", e.value)}
                  />
                </div>
                <div className="flex justify-between gap-2 w-full">
                  <SearchableDropdown2
                    label={"Type of Plastic"}
                    options={typeOfPlastic}
                    error={errors.typeOfPlastic}
                    selectedOption={
                      matchOption(
                        typeOfPlastic,
                        values.typeOfPlastic,
                        userData?.typeOfPlastic
                      ) ||
                      (values.typeOfPlastic
                        ? {
                            label: userData?.typeOfPlastic || "",
                            value: values.typeOfPlastic,
                          }
                        : null)
                    }
                    placeholder="Select  Type of Plastic"
                    handleChange={(e) =>
                      setFieldValue("typeOfPlastic", e.value)
                    }
                  />

                  <SearchableDropdown2
                    label={"Source of Plastic"}
                    options={sourceOfPlastic}
                    error={errors.sourceOfPlastic}
                    selectedOption={
                      matchOption(
                        sourceOfPlastic,
                        values.sourceOfPlastic,
                        userData?.sourceOfPlastic
                      ) ||
                      (values.sourceOfPlastic
                        ? {
                            label: userData?.sourceOfPlastic || "",
                            value: values.sourceOfPlastic,
                          }
                        : null)
                    }
                    placeholder="Select  Source of Plastic"
                    handleChange={(e) =>
                      setFieldValue("sourceOfPlastic", e.value)
                    }
                  />
                </div>
                <div className="flex flex-col">
                  <DatePicker
                    selected={
                      values.transactionDate
                        ? moment(values.transactionDate).toDate()
                        : startDate || null
                    }
                    onChange={(date) => {
                      setStartDate(date);
                      setFieldValue(
                        "transactionDate",
                        moment(date).format("YYYY-MM-DD")
                      );
                    }}
                    customInput={<ExampleCustomInput />}
                    showYearDropdown
                    yearDropdownItemNumber={100}
                    scrollableYearDropdown
                  />
                  {/* {errors.dateOfBirth ? (
                      <p className="text-red-500">{errors.dateOfBirth}</p>
                    ) : (
                      ""
                    )} */}
                </div>

                <div className="w-full">
                  <InputFile
                    label="Upload Waybill"
                    error={errors.file}
                    handleChange={(e) =>
                      setFieldValue("file", e.target.files[0])
                    }
                  />
                </div>

                <br />

                <div className="flex gap-2 justify-center">
                  <button
                    className="mx-auto px-2 w-full h-[40px] font-normal text-xs flex justify-center items-center gap-3 disabled:cursor-not-allowed border border-pfBlack md:w-272"
                    onClick={() => closeModal()}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={loading ? true : false}
                    onClick={handleSubmit}
                    className="bg-green-700 text-white flex justify-center items-center h-[40px] w-full gap-2"
                  >
                    {loading
                      ? isEdit
                        ? "Updating..."
                        : "Creating..."
                      : isEdit
                        ? "Update Offtake"
                        : "Create Offtake"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
